import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import FmyqDetail from "../views/FmyqDetail.vue";
import JhyjDetail from "../views/JhyjDetail";
import JhyjDetail2 from "../views/JhyjDetail2";
import CyltpDetail from "../views/CyltpDetail";
import SearchStock from "../views/SearchStock";
import HyjqDetail from "../views/hyjqDetail";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "",
    component: Home,
  },
  {
    path: "/home",
    name: "home",
    component: Home,
  },
  {
    path: "/fmyqDetail",
    name: "fmyqDetail",
    component: FmyqDetail,
  },
  {
    path: "/jhyjDetail",
    name: "jhyjDetail",
    component: JhyjDetail,
  },
  {
    path: "/jhyjDetail2",
    name: "jhyjDetail2",
    component: JhyjDetail2,
  },
  {
    path: "/search",
    name: "search",
    component: SearchStock,
  },
  {
    path: "/cyltpDetail",
    name: "cyltpDetail",
    component: CyltpDetail,
  },
  {
    path: "/hyjqDetail",
    name: "hyjqDetail",
    component: HyjqDetail,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.NODE_ENV === "development" ? "/" : process.env.VUE_APP_URL,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
